import { LegalLayout } from "@/pages/legal/LegalLayout";
import { privacyContent } from "@/legal/legalContent";

export default function PrivacyPage() {
  return <LegalLayout content={privacyContent} testId="privacy-page" />;
}
